module.exports = __webpack_public_path__ + "static/media/CARD_BACK.68d1bcdc.png";